import { environment } from '@environments/environment'
import { useAppState } from '@context/AppContext'
import { useEffect, useMemo } from 'react'
import { SearchParam } from '../common/SearchParam'

export function useAppUrl(normalUrl: string) {
  const appState = useAppState()

  return useMemo(() => {
    if (!environment.appUrlOverride) {
      return normalUrl
    }
    if (!appState?.initialSearchParams) {
      return null
    }
    const appUrl = appState.initialSearchParams.get(SearchParam.AppUrl)
    return appUrl ?? normalUrl
  }, [appState?.initialSearchParams])
}
